import commonMapping from "@/mapping/common";

const tun_proto_list = [
  { id: "tun_protocol_udp", value: "udp", config: "udp", label: "UDP" },
  { id: "tun_protocol_tcp", value: "tcp", config: "tcp", label: "TCP" },
];

const tap_proto_list = [
  { id: "protocol_udp", value: "udp", config: "udp", label: "UDP" },
  { id: "protocol_tcp", value: "tcp", config: "tcp", label: "TCP" },
];

const access_mode_list = [
  { id: "redirectgw_auto", value: "auto", config: "auto", label: "auto" },
  { id: "redirectgw_all", value: "all", config: "all", label: "inter_home_network" },
  { id: "redirectgw_only_lan", value: "onlylan", config: "home", label: "home_network" },
];

export const vpnService = {
  vpnservice_enable: commonMapping.intToBoolean,
  tun_proto: tun_proto_list,
  tap_proto: tap_proto_list,
  access_mode: access_mode_list,
};

export default vpnService;
